import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/category/movie', label: '电影频道' },
  { to: '/category/tv', label: '电视剧频道' },
  { to: '/category/movie/filter', label: '影视筛选' },
  { to: '/news', label: '影视资讯' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="container-page py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="text-lg font-bold text-background-50">
                天堂<span className="text-accent-400">影视</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              天堂影视致力于为影视爱好者提供最新电影、电视剧的浏览与资讯服务，涵盖多种类型与热门剧集，
              帮助用户快速发现值得观看的精彩内容。
            </p>
            <p className="mt-4 text-xs text-background-300/60">
              本站所有影视内容均为演示数据，播放功能为演示状态，正式接口待接入。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#footer-nav" className="cursor-pointer">快速导航</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul id="footer-contact" className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@paradisetv.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                <span>400-000-6688</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>浙江省杭州市滨江区影视产业园 A 座</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800/60 pt-6 text-xs text-background-300/60 sm:flex-row">
          <p>© 2025 天堂影视 Paradise TV. 保留所有权利。</p>
          <p>本站内容仅供演示，不提供任何实际影视资源。</p>
        </div>
      </div>
    </footer>
  );
}